import dynamic from 'next/dynamic';
import css from './solartracker.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';

const PageConPc = dynamic(() => import('@/components/productSmart/solartracker/indexDynamic'), {
    ssr: true,
});

export default function SolarTracker() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solartracker');
    const { locale } = useRouter();
    const webpUrl = '/media/solartracker/pc/';
    const banner_items = [
        {
            bgImgs: ['solartracker-banner.webp', 'solartracker-banner.jpg'],
            title: t('solar_tracker.title'),
            des: t('solar_tracker.subtitle'),
        },
    ];
    return (
        <div className={`${css.solartracker}`}>
            <div style={{ width: '100%', marginTop: '-65px' }}>
                <BannerModule
                    config={{
                        position: 'top',
                        titleFontSize: 80,
                        theme: 'black',
                        desFontSize: locale === 'jp' ? '26' : '28',
                        webpUrl,
                    }}
                    data={banner_items}
                />
            </div>
            <PageConPc />
        </div>
    );
}
